import { React } from "react";
import { Card } from "antd";
import Slider from "react-slick";
import { Button } from "../../../components";
import { sliderSettings } from "../config";

const tabs = [
  {
    name: "All Post",
    active: true
  },
  {
    name: "About",
    active: false
  },
  {
    name: "Featured",
    active: false
  },
  {
    name: "Members",
    active: false
  },
  {
    name: "Report",
    active: false
  },
  {
    name: "All Post",
    active: true
  },
  {
    name: "About",
    active: false
  },
  {
    name: "Featured",
    active: false
  },
  {
    name: "Members",
    active: false
  },
  {
    name: "Report",
    active: false
  },
];

const NavigationTabs = () => {
  return (
    <Card style={{padding: 20, borderRadius: 10}}>
      <Slider {...sliderSettings}>
        <div></div>
        {tabs.map((item, index) => (
          <div key={index}>
            <Button
              type="primary"
              className={`mt-0 primary-color ${item.active ? "button-tetiary" : "button-transparent-tetiary"}`}
              title={item.name}
              style={{
                height: "50px",
                borderRadius: "30px",
                paddingLeft: "2.5em",
                paddingRight: "2.5em",
              }}
            />
          </div>
        ))}
      </Slider>
    </Card>
  );
};

export default NavigationTabs;